export default __webpack_public_path__ + "static/media/img_illust02-membership.0afe46a0.png";